import React from 'react';

// Ligne « contrôle + libellé » du panneau de droite : bouton à gauche, libellé
// texte à droite, toujours visible. Les tooltips seuls ne suffisent pas dans le
// panel — une icône @ ou image ne dit pas ce qu'elle insère. La barre flottante
// sur canvas garde, elle, la version icône seule.
// Seul le bouton est cliquable : le libellé force le curseur par défaut pour ne
// pas laisser croire le contraire, quel que soit le style hérité du panneau.
const labelStyle = {
  cursor: 'default',
  fontSize: 12,
  fontWeight: 500,
  color: 'rgba(11, 34, 57, 0.65)',
  whiteSpace: 'nowrap',
};

const ControlLabelRow = ({ control, label }) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: 8, width: '100%' }}>
    {control}
    <span style={labelStyle}>{label}</span>
  </div>
);

export default ControlLabelRow;
